import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const CommentIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M14.1663 3.33301C14.1663 3.11211 14.0784 2.90034 13.9222 2.74414C13.7659 2.58796 13.5543 2.5 13.3333 2.5H2.66634C2.44545 2.50009 2.23368 2.58794 2.07748 2.74414C1.92127 2.90034 1.83342 3.11211 1.83334 3.33301V14.126L3.25619 12.7041C3.59991 12.3603 4.06594 12.1671 4.55209 12.167H13.3333C13.5542 12.167 13.766 12.0789 13.9222 11.9229C14.0785 11.7666 14.1663 11.554 14.1663 11.333V3.33301ZM15.1663 11.333C15.1663 11.8192 14.9731 12.2861 14.6292 12.6299C14.2854 12.9735 13.8194 13.167 13.3333 13.167H4.55209C4.3311 13.167 4.11946 13.2548 3.96322 13.4111L2.49447 14.8789C2.35837 15.0149 2.18513 15.108 1.99642 15.1455C1.80767 15.183 1.61171 15.1635 1.43392 15.0898C1.25619 15.0162 1.1043 14.8914 0.997398 14.7314C0.890445 14.5714 0.833361 14.3829 0.833336 14.1904V3.33301C0.833422 2.84689 1.02671 2.38085 1.37045 2.03711C1.71419 1.69337 2.18023 1.50009 2.66634 1.5H13.3333C13.8195 1.5 14.2854 1.69339 14.6292 2.03711C14.973 2.38085 15.1663 2.84689 15.1663 3.33301V11.333Z"
      fill="currentColor"
    />
    <path
      d="M8.00684 6.58331C8.42097 6.5834 8.75684 6.91916 8.75684 7.33331C8.75684 7.74747 8.42097 8.08322 8.00684 8.08331H8C7.58579 8.08331 7.25 7.74753 7.25 7.33331C7.25 6.9191 7.58579 6.58331 8 6.58331H8.00684Z"
      fill="currentColor"
    />
    <path
      d="M10.6735 6.58331C11.0876 6.5834 11.4235 6.91916 11.4235 7.33331C11.4235 7.74747 11.0876 8.08322 10.6735 8.08331H10.6667C10.2525 8.08331 9.91666 7.74753 9.91666 7.33331C9.91666 6.9191 10.2525 6.58331 10.6667 6.58331H10.6735Z"
      fill="currentColor"
    />
    <path
      d="M5.34017 6.58331C5.75431 6.5834 6.09017 6.91916 6.09017 7.33331C6.09017 7.74747 5.75431 8.08322 5.34017 8.08331H5.33334C4.91912 8.08331 4.58334 7.74753 4.58334 7.33331C4.58334 6.9191 4.91912 6.58331 5.33334 6.58331H5.34017Z"
      fill="currentColor"
    />
  </svg>
);
